module.exports = __webpack_public_path__ + "img/queenslander-type-2.afce7564.jpg";